import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Menu,
  MenuTrigger,
  MenuPopover,
  MenuList,
  MenuItem,
} from '@fluentui/react-components';
import {
  Delete20Regular,
  Edit20Regular,
  MoreHorizontal20Regular,
} from '@fluentui/react-icons';
/**
 * Composant label pour le nœud Resource Account
 * Affiche seulement "Appel Entrant" et le nom du callflow
 */
const ResourceAccountNodeLabel = ({ callFlowData, handleEditNode, handleDeleteNode }) => {
  const { t } = useTranslation();
  return (
    <div 
      className="node-resource-account"
      onClick={() => handleEditNode('resource-account')}
      style={{ 
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        padding: '20px',
        position: 'relative'
      }}
    >
      <Menu>
        <MenuTrigger disableButtonEnhancement>
          <button
            className="node-menu-btn"
            onClick={(e) => e.stopPropagation()}
            title="Options"
            style={{
              position: 'absolute',
              top: '-20px',
              left: '50%',
              transform: 'translateX(-50%)'
            }}
          >
            <MoreHorizontal20Regular />
          </button>
        </MenuTrigger>
        <MenuPopover>
          <MenuList>
            <MenuItem
              onClick={(e) => {
                e.stopPropagation();
                handleEditNode('resource-account');
              }}
            >
              <Edit20Regular style={{ marginRight: '8px' }} />
              {t('EDIT')}
            </MenuItem>
          </MenuList>
        </MenuPopover>
      </Menu>
      <div style={{
        fontSize: '24px',
        marginBottom: '4px'
      }}></div>
      <div style={{
        fontWeight: 600,
        fontSize: '14px',
        textAlign: 'center',
        color: '#5b5fc7'
      }}>{t('INCOMING_CALL')}</div>
    </div>
  );
};
export default ResourceAccountNodeLabel;
